/* Build-your-own advent calendar.

   Each spot is one advent Sunday. Picking a product fills the first empty spot;
   the pick is sent to the cart as its own line item carrying a line item
   property naming the Sunday, e.g. "Adventssøndag: 2. søndag".

   That property is also what keeps the lines separate: Shopify merges lines
   with the same variant id, but only when their properties match too - so the
   same product in two spots stays as two distinct lines.

   Selection state is in memory only, by design: the grid never reloads. The
   section renders the first page of products; the rest are fetched through the
   Section Rendering API and appended (see loadRemainingPages), and the grid is
   then paged client-side (see showPage), so paging never loses the picks.

   Any all-4 discount is expected to be a Shopify automatic discount, so nothing
   here applies or displays one - the total shown is the plain sum of the picks. */
(function () {
  var root = document.querySelector('[data-advent]');
  if (!root) return;

  var SPOT_COUNT = parseInt(root.dataset.spotCount, 10) || 4;
  var PROPERTY_NAME = root.dataset.propertyName || 'Advent';
  var CHOOSE_TEXT = root.dataset.chooseText || '';
  var REMOVE_TEXT = root.dataset.removeText || CHOOSE_TEXT;
  var DISCOUNT_PERCENT = parseFloat(root.dataset.discountPercent) || 0;
  var DISCOUNT_REQUIRES_ALL = root.dataset.discountRequiresAll === 'true';
  var MESSAGE_START = root.dataset.messageStart || '';
  var MESSAGE_PROGRESS = root.dataset.messageProgress || '';
  var MESSAGE_SAVED = root.dataset.messageSaved || '';

  var bar = root.querySelector('[data-advent-bar]');
  var totalWasEl = root.querySelector('[data-advent-total-was]');
  var totalNowEl = root.querySelector('[data-advent-total-now]');
  var submitEl = root.querySelector('[data-advent-submit]');
  var messageEl = root.querySelector('[data-advent-message]');
  var spotEls = Array.prototype.slice.call(root.querySelectorAll('[data-advent-spot]'));

  // picks[i] is the variant chosen for spot i, or null.
  var picks = new Array(SPOT_COUNT).fill(null);

  function money(cents) {
    if (typeof formatMoney === 'function' && window.theme && window.theme.settings) {
      return formatMoney(cents, window.theme.settings.money_with_currency_format || '${{amount}}');
    }
    return (cents / 100).toFixed(2);
  }

  function spotLabel(index) {
    return spotEls[index].querySelector('.advent__spot-label').textContent.trim();
  }

  function firstEmptySpot() {
    for (var i = 0; i < picks.length; i++) {
      if (!picks[i]) return i;
    }
    return -1;
  }

  function variantsFor(card) {
    var json = card.querySelector('[data-advent-variants]');
    if (!json) return [];
    try {
      return JSON.parse(json.textContent);
    } catch (e) {
      return [];
    }
  }

  function closeAllVariantPanels() {
    root.querySelectorAll('[data-advent-variants-panel]').forEach(function (panel) {
      panel.hidden = true;
    });
  }

  function render() {
    var total = 0;
    var filled = 0;

    spotEls.forEach(function (spotEl, index) {
      var pick = picks[index];
      var thumb = spotEl.querySelector('[data-advent-spot-thumb]');
      var remove = spotEl.querySelector('[data-advent-remove]');

      spotEl.classList.toggle('is-filled', !!pick);

      if (pick) {
        total += pick.price;
        filled += 1;
        thumb.style.backgroundImage = pick.image ? 'url("' + pick.image + '")' : '';
        thumb.title = pick.productTitle;
        remove.hidden = false;
      } else {
        thumb.style.backgroundImage = '';
        thumb.removeAttribute('title');
        remove.hidden = true;
      }
    });

    /* Discount preview. The reduction itself is a Shopify automatic discount
       applied at the cart; this only shows what it will come to, so the two
       must be configured to agree. Rounded to the whole minor unit, the same
       way Shopify rounds a percentage discount. */
    var discountApplies =
      DISCOUNT_PERCENT > 0 &&
      total > 0 &&
      (!DISCOUNT_REQUIRES_ALL || filled === SPOT_COUNT);

    var discounted = Math.round(total * (100 - DISCOUNT_PERCENT) / 100);

    if (discountApplies) {
      totalWasEl.hidden = false;
      totalWasEl.textContent = money(total);
      totalNowEl.textContent = money(discounted);
    } else {
      totalWasEl.hidden = true;
      totalWasEl.textContent = '';
      totalNowEl.textContent = money(total);
    }

    // What the customer gets out of it, in words: how far off the discount
    // is, then how much it saves once reached.
    if (messageEl) {
      var message = '';
      if (discountApplies) {
        message = MESSAGE_SAVED.replace('[saving]', money(total - discounted));
      } else if (DISCOUNT_PERCENT > 0) {
        message = filled === 0 ? MESSAGE_START : MESSAGE_PROGRESS;
      }
      messageEl.textContent = message
        .replace('[remaining]', SPOT_COUNT - filled)
        .replace('[count]', SPOT_COUNT)
        .replace('[percent]', DISCOUNT_PERCENT + '%');
      messageEl.hidden = !message;
      messageEl.classList.toggle('is-saved', discountApplies);
    }

    submitEl.disabled = filled === 0;
    bar.classList.toggle('is-active', filled > 0);

    // Which spot, if any, each product currently occupies - the badge shows
    // that spot's label so the card says "1. søndag" rather than just "picked".
    var spotByProduct = {};
    picks.forEach(function (pick, index) {
      if (pick) spotByProduct[pick.productId] = index;
    });

    var isFull = firstEmptySpot() === -1;

    root.querySelectorAll('[data-advent-product]').forEach(function (card) {
      var spotIndex = spotByProduct[card.dataset.productId];
      var isPicked = spotIndex !== undefined;
      var button = card.querySelector('[data-advent-choose]');
      var badge = card.querySelector('[data-advent-badge]');

      card.classList.toggle('is-picked', isPicked);

      if (badge) {
        badge.hidden = !isPicked;
        // Cleared rather than left stale, so a deselected card carries no
        // leftover label even if something overrides [hidden] again.
        badge.textContent = isPicked ? spotLabel(spotIndex) : '';
      }

      if (button) {
        // A picked product stays clickable so it can be deselected; only
        // unpicked ones are locked out once every spot is taken.
        button.disabled = !isPicked && isFull;

        // Written to the inner span, never the button: replacing the button's
        // textContent would delete that span and drop the label under the
        // .button:before sweep.
        var label = button.querySelector('[data-advent-choose-label]');
        if (label) label.textContent = isPicked ? REMOVE_TEXT : CHOOSE_TEXT;
      }
    });
  }

  function assign(card, variant) {
    var index = firstEmptySpot();
    if (index === -1) return;

    picks[index] = {
      id: variant.id,
      price: variant.price,
      image: variant.image,
      productId: card.dataset.productId,
      productTitle: variant.productTitle,
      variantTitle: variant.title
    };

    closeAllVariantPanels();
    render();
  }

  root.addEventListener('click', function (event) {
    var choose = event.target.closest('[data-advent-choose]');
    if (choose) {
      var card = choose.closest('[data-advent-product]');

      // Already in a spot -> clicking again takes it back out.
      var existing = picks.findIndex(function (pick) {
        return pick && pick.productId === card.dataset.productId;
      });
      if (existing !== -1) {
        picks[existing] = null;
        closeAllVariantPanels();
        render();
        return;
      }

      var variants = variantsFor(card);
      if (!variants.length) return;

      // One purchasable variant means there is nothing to ask about.
      if (variants.length === 1) {
        assign(card, variants[0]);
      } else {
        var panel = card.querySelector('[data-advent-variants-panel]');
        var wasOpen = panel && !panel.hidden;
        closeAllVariantPanels();
        if (panel) panel.hidden = wasOpen;
      }
      return;
    }

    var variantButton = event.target.closest('[data-advent-variant]');
    if (variantButton) {
      var variantCard = variantButton.closest('[data-advent-product]');
      var id = parseInt(variantButton.dataset.adventVariant, 10);
      var match = variantsFor(variantCard).filter(function (v) {
        return v.id === id;
      })[0];
      if (match) assign(variantCard, match);
      return;
    }

    var remove = event.target.closest('[data-advent-remove]');
    if (remove) {
      var spot = remove.closest('[data-advent-spot]');
      picks[parseInt(spot.dataset.adventSpot, 10)] = null;
      render();
    }
  });

  /* --- filters and sorting ----------------------------------------------
     Client-side only, over the cards already on the page: reloading through
     the theme's URL filters would throw away the picks held in memory. A
     picked product that gets filtered out stays in its spot.

     The markup is the theme's own facet bar and drawer, so this also stands in
     for the parts of facets.js those need: opening the drawer, the active
     filter chips and the product count. */
  var gridEl = root.querySelector('[data-advent-grid]');
  // Live lookup: later pages can add checkboxes (see mergeFilters)
  function checkboxes() {
    return Array.prototype.slice.call(root.querySelectorAll('[data-advent-filter]'));
  }
  var sortEls = Array.prototype.slice.call(root.querySelectorAll('[data-advent-sort]'));
  var drawerEl = root.querySelector('[data-advent-drawer]');
  var activeEl = root.querySelector('[data-advent-active]');
  var countEl = root.querySelector('[data-advent-count]');
  var noResultsEl = root.querySelector('[data-advent-no-results]');
  var chipIconEl = root.querySelector('[data-advent-chip-icon]');

  function cards() {
    return Array.prototype.slice.call(root.querySelectorAll('[data-advent-product]'));
  }

  function matches(card, key, value) {
    if (key === 'price') {
      // "min-max" in minor units; an empty max is open-ended
      var range = value.split('-');
      var price = parseInt(card.dataset.price, 10);
      return price >= parseInt(range[0], 10) && (range[1] === '' || price < parseInt(range[1], 10));
    }
    // List metafields arrive joined with "|", so any one value can match.
    return (card.dataset[key] || '').split('|').indexOf(value) !== -1;
  }

  function renderChips(checked) {
    if (!activeEl) return;
    activeEl.innerHTML = '';
    if (!checked.length) return;

    checked.forEach(function (el) {
      var chip = document.createElement('a');
      chip.href = '#';
      chip.className = 'active-facets__button';
      chip.textContent = el.dataset.label;
      chip.dataset.adventUncheck = el.id;
      var icon = document.createElement('span');
      if (chipIconEl) icon.innerHTML = chipIconEl.innerHTML;
      chip.appendChild(icon);
      activeEl.appendChild(chip);
    });

    var clear = document.createElement('a');
    clear.href = '#';
    clear.className = 'active-facets__button-remove text-button';
    clear.textContent = activeEl.dataset.clearText || '';
    clear.dataset.adventReset = '';
    activeEl.appendChild(clear);
  }

  // The count strings carry 9999 as a stand-in for the total (see the section)
  function totalText(template) {
    return template.replace('9999', cards().length);
  }

  function applyFilters(keepPage) {
    var checked = checkboxes().filter(function (el) {
      return el.checked;
    });

    // Within a group any ticked value matches; across groups, all must.
    var groups = {};
    checked.forEach(function (el) {
      var key = el.dataset.adventFilter;
      (groups[key] = groups[key] || []).push(el.value);
    });

    // In DOM order, i.e. the current sort order
    matched = cards().filter(function (card) {
      return Object.keys(groups).every(function (key) {
        return groups[key].some(function (value) {
          return matches(card, key, value);
        });
      });
    });
    var shown = matched.length;

    if (!keepPage) currentPage = 1;
    showPage();

    if (noResultsEl) noResultsEl.hidden = shown > 0;
    if (countEl) {
      countEl.textContent = checked.length
        ? totalText(countEl.dataset.countFiltered).replace('[shown]', shown)
        : totalText(countEl.dataset.countAll);
    }
    renderChips(checked);
  }

  /* --- pagination -----------------------------------------------------------
     Client-side over the filtered cards, in the theme's pagination markup. */
  var PER_PAGE = parseInt(root.dataset.perPage, 10) || 48;
  var paginationEl = root.querySelector('[data-advent-pagination]');
  var pagesEl = root.querySelector('[data-advent-pages]');
  var pageLabels = root.querySelector('[data-advent-page-labels]');
  var prevIcon = root.querySelector('[data-advent-page-prev]');
  var nextIcon = root.querySelector('[data-advent-page-next]');
  var matched = [];
  var currentPage = 1;

  function pageCount() {
    return Math.max(1, Math.ceil(matched.length / PER_PAGE));
  }

  function showPage() {
    currentPage = Math.min(Math.max(currentPage, 1), pageCount());
    var start = (currentPage - 1) * PER_PAGE;
    var onPage = matched.slice(start, start + PER_PAGE);
    cards().forEach(function (card) {
      card.hidden = onPage.indexOf(card) === -1;
    });
    renderPagination();
  }

  // 1 … 4 5 6 … 12: first, last, and the current page with its neighbours
  function pageList(total) {
    var list = [];
    for (var p = 1; p <= total; p++) {
      if (p === 1 || p === total || Math.abs(p - currentPage) <= 1) {
        list.push(p);
      } else if (list[list.length - 1] !== '…') {
        list.push('…');
      }
    }
    return list;
  }

  function pageLink(page, className, html, label) {
    var span = document.createElement('span');
    span.className = className;
    var link = document.createElement('a');
    link.href = '#';
    link.dataset.adventPage = page;
    link.innerHTML = html;
    if (label) link.setAttribute('aria-label', label);
    span.appendChild(link);
    return span;
  }

  function renderPagination() {
    if (!paginationEl || !pagesEl) return;
    var total = pageCount();
    paginationEl.hidden = total < 2;
    pagesEl.innerHTML = '';
    if (total < 2) return;

    var pageWord = (pageLabels && pageLabels.dataset.page) || '';
    if (currentPage > 1) {
      pagesEl.appendChild(pageLink(currentPage - 1, 'prev', prevIcon ? prevIcon.innerHTML : '‹', pageLabels && pageLabels.dataset.previous));
    }
    pageList(total).forEach(function (p) {
      if (p === '…') {
        var deco = document.createElement('span');
        deco.className = 'deco';
        deco.textContent = '…';
        pagesEl.appendChild(deco);
      } else if (p === currentPage) {
        var current = document.createElement('span');
        current.className = 'page current';
        current.setAttribute('aria-current', 'page');
        current.textContent = p;
        pagesEl.appendChild(current);
      } else {
        pagesEl.appendChild(pageLink(p, 'page', String(p), (pageWord + ' ' + p).trim()));
      }
    });
    if (currentPage < total) {
      pagesEl.appendChild(pageLink(currentPage + 1, 'next', nextIcon ? nextIcon.innerHTML : '›', pageLabels && pageLabels.dataset.next));
    }
  }

  function goToPage(page) {
    currentPage = page;
    showPage();
    // Back to the top of the grid (below the sticky header)
    var anchor = root.querySelector('.advent__facets') || gridEl;
    var header = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 0;
    var top = anchor.getBoundingClientRect().top + window.scrollY - header - 20;
    window.scrollTo({ top: top, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  }

  var currentSort = '';

  function applySort(order) {
    if (!gridEl) return;
    currentSort = order;
    // The bar and the drawer each have a sort select; keep them agreeing.
    sortEls.forEach(function (el) {
      el.value = order;
    });
    cards()
      .sort(function (a, b) {
        if (order === 'price-asc') return a.dataset.price - b.dataset.price;
        if (order === 'price-desc') return b.dataset.price - a.dataset.price;
        return a.dataset.index - b.dataset.index;
      })
      .forEach(function (card) {
        gridEl.appendChild(card);
      });
  }

  function resetFilters() {
    checkboxes().forEach(function (el) {
      el.checked = false;
    });
    applyFilters();
  }

  function closeDrawer() {
    // The theme's overlay click closes whichever side panel is open.
    var overlay = document.querySelector('.click-capture');
    if (overlay) overlay.click();
  }

  root.addEventListener('change', function (event) {
    if (event.target.matches('[data-advent-filter]')) applyFilters();
  });

  sortEls.forEach(function (el) {
    el.addEventListener('change', function () {
      applySort(el.value);
      applyFilters();
    });
  });

  root.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-advent-facets-toggle]');
    if (toggle && drawerEl) {
      event.preventDefault();
      drawerEl.classList.add('active');
      document.body.classList.add('open-cc');
      return;
    }

    var uncheck = event.target.closest('[data-advent-uncheck]');
    if (uncheck) {
      event.preventDefault();
      var box = document.getElementById(uncheck.dataset.adventUncheck);
      if (box) box.checked = false;
      applyFilters();
      return;
    }

    if (event.target.closest('[data-advent-reset]')) {
      event.preventDefault();
      resetFilters();
      return;
    }

    if (event.target.closest('[data-advent-apply]')) {
      closeDrawer();
      return;
    }

    var pageLinkEl = event.target.closest('[data-advent-page]');
    if (pageLinkEl) {
      event.preventDefault();
      goToPage(parseInt(pageLinkEl.dataset.adventPage, 10));
    }
  });

  /* --- add to cart ---------------------------------------------------------
     One request with every pick. The sections come back rendered so the cart
     drawer and the header count can be swapped in, matching what the theme's
     own quick-add does. */
  function sectionsToRender() {
    return [
      { id: 'Cart', section: 'main-cart', selector: '.thb-cart-form' },
      { id: 'Cart-Drawer', section: 'cart-drawer', selector: '.cart-drawer' },
      { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-item-count' }
    ];
  }

  function renderCart(state) {
    sectionsToRender().forEach(function (section) {
      var host = document.getElementById(section.id);
      if (!host || !state.sections || !state.sections[section.section]) return;

      var target = host.querySelector(section.selector) || host;
      var parsed = new DOMParser().parseFromString(state.sections[section.section], 'text/html');
      var source = parsed.querySelector(section.selector);
      if (source) target.innerHTML = source.innerHTML;
    });

    if (typeof CartDrawer !== 'undefined') new CartDrawer();

    var drawer = document.getElementById('Cart-Drawer');
    if (drawer) {
      drawer.classList.add('active');
      document.body.classList.add('open-cart', 'open-cc');
      if (typeof dispatchCustomEvent === 'function') dispatchCustomEvent('cart-drawer:open');
    }
  }

  submitEl.addEventListener('click', function () {
    var chosen = picks
      .map(function (pick, index) {
        if (!pick) return null;
        var properties = {};
        properties[PROPERTY_NAME] = spotLabel(index);
        return { id: pick.id, quantity: 1, properties: properties };
      })
      .filter(Boolean);

    if (!chosen.length) return;

    submitEl.classList.add('loading');
    submitEl.disabled = true;

    fetch(window.theme.routes.cart_add_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: chosen,
        sections: sectionsToRender().map(function (s) {
          return s.section;
        }),
        sections_url: window.location.pathname
      })
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (state) {
        if (state.status) return;

        renderCart(state);
        picks = new Array(SPOT_COUNT).fill(null);
        render();
      })
      .catch(function (error) {
        console.error(error);
      })
      .finally(function () {
        submitEl.classList.remove('loading');
        render();
      });
  });

  /* --- remaining pages -----------------------------------------------------
     Fetched one at a time after the first paint. Each response is this section
     rendered for that page: its cards are appended, and any filter option not
     yet in the drawer is added in alphabetical order. Filters, sorting and the
     picks then apply to the new cards like to the first ones. */
  var loadingEl = root.querySelector('[data-advent-loading]');
  var PAGES = parseInt(root.dataset.pages, 10) || 1;
  var SECTION_ID = root.dataset.sectionId;

  function mergeFilters(doc) {
    doc.querySelectorAll('[data-advent-filter]').forEach(function (incoming) {
      var key = incoming.dataset.adventFilter;
      var exists = checkboxes().some(function (el) {
        return el.dataset.adventFilter === key && el.value === incoming.value;
      });
      var group = root.querySelector('[data-advent-group="' + key + '"]');
      var list = group && group.querySelector('ul');
      if (exists || !list) return;

      var item = document.importNode(incoming.closest('li'), true);
      var input = item.querySelector('input');
      var label = item.querySelector('label');
      // The section numbers ids per page, so they repeat across pages
      var id = 'AdventFilter-' + key + '-p' + Math.random().toString(36).slice(2, 8);
      input.id = id;
      if (label) label.setAttribute('for', id);

      var before = Array.prototype.slice.call(list.children).find(function (li) {
        var other = li.querySelector('input');
        return other && other.dataset.label.localeCompare(input.dataset.label, 'da', { numeric: true }) > 0;
      });
      list.insertBefore(item, before || null);
      if (list.querySelectorAll('input').length > 1) group.hidden = false;
    });
  }

  function appendCards(doc) {
    var known = {};
    cards().forEach(function (card) {
      known[card.dataset.productId] = true;
    });
    doc.querySelectorAll('[data-advent-product]').forEach(function (card) {
      if (known[card.dataset.productId]) return;
      gridEl.appendChild(document.importNode(card, true));
    });
  }

  function loadRemainingPages() {
    if (PAGES < 2 || !SECTION_ID || !gridEl) return;
    var page = 2;

    function next() {
      if (page > PAGES) {
        if (loadingEl) loadingEl.hidden = true;
        return;
      }
      var url = window.location.pathname + '?section_id=' + encodeURIComponent(SECTION_ID) + '&page=' + page;
      fetch(url, { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('HTTP ' + response.status);
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          appendCards(doc);
          mergeFilters(doc);
          applySort(currentSort);
          applyFilters(true);
          render();
          page += 1;
          next();
        })
        .catch(function (error) {
          // Keep what loaded; the first page stays fully usable
          console.error('Advent calendar: could not load page ' + page, error);
          if (loadingEl) loadingEl.hidden = true;
        });
    }
    next();
  }

  render();
  applyFilters();
  loadRemainingPages();
})();
